import {
  deleteRequest,
  get,
  patch,
  post,
  put,
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import { AnyAaaaRecord } from "node:dns";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";
import { Data } from "@react-google-maps/api";



export const getCategoryOptions = async (
  data: any
): Promise<DataResponse<any>> =>{
  const url = `${endpoints.getOptionsByCategoryId}?CategoryId=${data.categoryId}`;
  console.log(url)
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getCategoryFilter = async (
  filter?: any
): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryFilter}?${query?query:""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getCategoryTreeWithChildrenFilter = async (
  filter?: any
): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryTreeWithChildren}?FilterUrl=${filter?.Url||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getCategoryTreeByUrlFilter = async (
  filter?: any
): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryTreeWithChildrenById}?FilterUrl=${filter?.Url||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const GetCategoryTreeWithTopCategoryByUrlAsync = async (
  filter?: any
): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryTreeWithTopCategoryByUrlAsync}?FilterUrl=${filter?.Url||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getCategoryTreeById= async (
  filter?: any
): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryTreeWithChildrenById}?${query?query:""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const createAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.createAdvert}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};
export const createPayment = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.createPayment}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};
export const patchAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.patchAdvert}/${data.id}`;
  console.log(url)
  const config = headers.content_type.application_json;
  return patch<DataResponse<any>>(url, data.patch, config);
};
export const addMediaByAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.addMediaByAdvert}`;
  const config = headers.content_type.multipart_form_data;
  return post<DataResponse<any>>(url, data, config);
};
export const addContactTypeByAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.addContactTypeByAdvert}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};
export const updateMediaByAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.updateMediaByAdvert}`;
  const config = headers.content_type.multipart_form_data;
  return put<DataResponse<any>>(url, data, config);
};
export const deleteMediaByAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.deleteMediaByAdvert}/${data.mediaId}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, {}, config);
};
export const editAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.editAdvert}`;
  const config = headers.content_type.application_json;
  return put<DataResponse<any>>(url, data, config);
};
export const addImageInAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.addImageInAdvert}`;
  const config = headers.content_type.multipart_form_data;
  return post<DataResponse<any>>(url, data, config);
};
// export const getOptionsListByCategory = async (
// filter:any
// ): Promise<DataResponse<any>> => {
//   let query = filter?CreateUrlFilter(filter):null
//   const url = `${endpoints.getOptionsByCategoryId}?CategoryId=${query}`;
//   const config = headers.content_type.application_json;
//   return get<DataResponse<any>>(url, config);
// };
export const getOptionsListByCategory = async (
  filter: any
): Promise<DataResponse<any>> => {
  let query = filter?CreateUrlFilter(filter):null
  let url = endpoints.getOptionsByCategoryId;

  if (filter && typeof filter !== "object") {
    url += `?CategoryId=${filter}`;
  }else{
    url+=`?${query}`;
  }

  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getPackageList = async (): Promise<DataResponse<any>> => {
  const url = `${endpoints.getPackages}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getAdvertCategoryDetails = async (categoryId:number|string): Promise<DataResponse<any>> => {
  const url = `${endpoints.getAdvertCategoryDetails}?Id=${categoryId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getContractTypeById= async (typeId:string): Promise<DataResponse<any>> => {
  const url = `${endpoints.getContractTypeById}?Id=${typeId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const getInstallmentAccordingCard = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.getInstallment}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url,data, config);
};
export const getDopingList = async (): Promise<DataResponse<any>> => {
  const url = `${endpoints.getDopings}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getAdvertImages = async (
  adId: string | null
): Promise<DataResponse<any>> => {
  const url = `${endpoints.getMediaByAdvert}/${adId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};


export const getDocumentByAdvert = async (
  adId: string | null
): Promise<DataResponse<any>> => {
  const url = `${endpoints.getDocumentByAdvert}/${adId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const addDocumentByAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.addDocumentByAdvert}`;
  const config = headers.content_type.multipart_form_data;
  return post<DataResponse<any>>(url, data, config);
};
export const deleteDocumentByAdvert = async (
  data: any
): Promise<DataResponse<AnyAaaaRecord>> => {
  const url = `${endpoints.deleteDocumentByAdvert}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, {}, config);
};

export const EIDSAuthenticatUser = async (
 
): Promise<DataResponse<any>> => {
  const url = `${endpoints.EIDSAuthenticateUser}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const EIDSTasinmazValidate = async (
 data:any
): Promise<DataResponse<any>> => {
  const url = `${endpoints.EidsTasinmazValidate}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};

export const  updateFaultyPieceAttr = (data:any)=>{
  const url = `${endpoints.updateFaultyPieceAttr}`;
  const config = headers.content_type.application_json;
  return put<DataResponse<any>>(url, data,config);
}

export const EIDSAracValidate = async (
  data:any
 ): Promise<DataResponse<any>> => {
   const url = `${endpoints.EidsAracValidate}`;
   const config = headers.content_type.application_json;
   return post<DataResponse<any>>(url, data,config);
 };

